<template>
    <v-card :width="isDesktop ? 350 : '100%'" class="ma-auto" flat :outlined="isDesktop" tile>
        <v-container fluid class="signup-container py-5">
            <reset-form></reset-form>
        </v-container>
    </v-card>
</template>
<script>
import resetForm from "@/components/forms/form-reset-password.vue"

export default {
    components: {
        resetForm
    }
}
</script>